import { render, staticRenderFns } from "./StarredMessageRow.vue?vue&type=template&id=9f063938&scoped=true&"
import script from "./StarredMessageRow.vue?vue&type=script&lang=js&"
export * from "./StarredMessageRow.vue?vue&type=script&lang=js&"
import style0 from "./StarredMessageRow.vue?vue&type=style&index=0&id=9f063938&scoped=true&lang=css&"
import style1 from "./StarredMessageRow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f063938",
  null
  
)

export default component.exports